export default "__VITE_ASSET__CpjVqFea__"